export abstract class EntityModel {
    // @ts-ignore
    static abstract getSchema();

}
